// @module Tavano.SummaryMessage.SummaryMessage
define('Tavano.SummaryMessage.SummaryMessage.View'
,	[
		'tavano_summarymessage_summarymessage.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	, 'LiveOrder.Model'
	,	'underscore'
	]
,	function (
		tavano_summarymessage_summarymessage_tpl
	,	Utils
	,	Backbone
	,	jQuery
	, LiveOrderModel
	,	_
	)
{
	'use strict';

	// @class Tavano.SummaryMessage.SummaryMessage.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavano_summarymessage_summarymessage_tpl
	,	initialize: function (options) {
			console.log(options)
			this.liveorder = LiveOrderModel.getInstance();

			console.log(this.liveorder.get('summary').discountedsubtotal);

			this.showMessage = false;

			if (this.liveorder.get('summary').discountedsubtotal <= 150) {
				this.showMessage = true;
			}
			
			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/SummaryMessage.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
	}

	,	events: {
		'click [data-action="back-to-shopping"]': 'goShopping',
		}
	
	, goShopping: function() {
		Backbone.history.navigate('/' ,{ trigger:true })
	}

	,	bindings: {
		
		}

	, 	childViews: {
			
		}

		//@method getContext @return Tavano.SummaryMessage.SummaryMessage.View.Context
	,	getContext: function getContext()
		{
			//@class Tavano.SummaryMessage.SummaryMessage.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message,
				showMessage: this.showMessage
			};
		}
	});
});
